import React from 'react';
import logoWhite from '../../../images/Logo/MrSea2025_logo_white.png';

const LandingFooter = () => {
  return (
    <footer className="landing-footer">
      <div className="landing-footer__inner">
        <img
          src={logoWhite}
          alt="Mr Sea Miami"
          className="landing-footer__logo"
        />
      </div>
    </footer>
  );
};

export default LandingFooter;
